import React from "react";

export const SocketStatus = () => {
  return (
    <>
      {/* <div
        style={{ width: 35, height: 35 }}
        className={`${
          socket ? (connected ? "bg-success" : "bg-error") : "bg-error"
        } fixed-bottom fabl mb-2 ml-5 pt-1`}
      >
        <FontAwesomeIcon
          icon={
            // socket
            //   ? socket.connected
            //     ? faServer
            //     : faRobot
            //   : online
            //   ? faServer
            //   : faRobot
            connected ? faServer : faRobot
          }
        ></FontAwesomeIcon>
      </div> */}
    </>
  );
};
